import { OptionInput } from '@/types/schema';

export enum QuizOptionsActionEnum {
  AddOption = 'ADD_OPTION',
  AddOptions = 'ADD_OPTIONS',
  UpdateOption = 'UPDATE_OPTION',
  RemoveOption = 'REMOVE_OPTION',
  ReorderOption = 'REORDER_OPTION',
  SetOptionEvaluation = 'SET_OPTION_EVALUATION',
}

interface AddOptionAction {
  type: QuizOptionsActionEnum.AddOption;
}

export interface UpdateOptionAction {
  type: QuizOptionsActionEnum.UpdateOption;
  payload: {
    option: OptionInput;
    index: number;
  };
}

export interface AddOptionsAction {
  type: QuizOptionsActionEnum.AddOptions;
  payload: {
    newOptions: OptionInput[];
  };
}

interface RemoveOptionAction {
  type: QuizOptionsActionEnum.RemoveOption;
  payload: {
    index: number;
  };
}

interface ReorderOptionAction {
  type: QuizOptionsActionEnum.ReorderOption;
  payload: {
    fromIndex: number;
    toIndex: number;
  };
}

export interface SetOptionEvaluationAction {
  type: QuizOptionsActionEnum.SetOptionEvaluation;
  payload: {
    index: number;
    optionEvaluation: boolean;
  };
}

export type QuizOptionsActions =
  | AddOptionAction
  | UpdateOptionAction
  | RemoveOptionAction
  | ReorderOptionAction
  | SetOptionEvaluationAction
  | AddOptionsAction;

export type onQuizOptionsAction = (action: QuizOptionsActions) => void;
